export default __webpack_public_path__ + "static/media/lesMillsWhite.b8ae9a1d.svg";